import "@styles/index.scss";
import data from "/../static/data/data.json";
import Experience from "./Experience/Experience";
import gsap from "gsap";

window.addEventListener('pageshow', (e) => {
  if (e.persisted && performance?.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    location.reload();
  }
});

const experience = new Experience(document.querySelector("canvas.webgl"));

  gsap.fromTo(
    ".nav-left",
    { opacity: 0, },
    { opacity: 1, ease: "power1.in", duration: .6, delay: 2.5 }
  );
    gsap.fromTo(
    ".nav-right",
    { opacity: 0, },
    { opacity: 1, ease: "power1.in", duration: .6, delay: 2.5  }
  );
      gsap.fromTo(
    ".scrollPercentage-scroll",
    { opacity: 0, },
    { opacity: 1, ease: "power1.in", duration: .6, delay: 2.5 }
  );
      gsap.fromTo(
    ".scrollPercentage-scrollDown",
    { opacity: 0, },
    { opacity: 1, ease: "power1.in", duration: .6, delay: 2.5 }
  );

const debounce = (fn, delay = 150) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(null, args), delay);
  };
};

const PHONE_MQ = "(max-width: 920px)";
const mq = window.matchMedia(PHONE_MQ);


window.addEventListener("pageshow", (e) => {
  const navType = performance?.getEntriesByType("navigation")[0]?.type;
  if (e.persisted && navType === "back_forward") {
    location.reload();
  }
});


function renderPhoneProjects(json) {
  const phoneSection = document.querySelector(".phone");
  if (!phoneSection) return;

  gsap.killTweensOf(".phone-grid a");
  phoneSection.innerHTML = "";

  const grid = document.createElement("div");
  grid.className = "phone-grid";

  for (const { image, name, date, slug } of json) {
    const card = document.createElement("a");
    card.href = `/pages/${slug}.html`;
    card.className = "phone-grid-card";

    const img = document.createElement("img");
    img.src = image;
    img.alt = name;

    const h3 = document.createElement("h3");
    h3.textContent = name;

    const time = document.createElement("time");
    time.textContent = date;

    card.append(img, h3, time);
    grid.appendChild(card);
  }

  phoneSection.appendChild(grid);

  gsap.fromTo(
    ".phone-grid a",
    { y: 1200, opacity: 0 },
    { y: 0, opacity: 1, ease: "circ.out", duration: 1, delay: 0.4 }
  );
}

function destroyPhoneProjects() {
  const phoneSection = document.querySelector(".phone");
  if (!phoneSection) return;
  gsap.killTweensOf(".phone-grid a");
  phoneSection.innerHTML = "";
}

let experienceInstance = null;

function startExperience() {
  if (experienceInstance) return;
  const canvas = document.querySelector("canvas.webgl");
  if (!canvas) return;
  experienceInstance = new Experience(canvas);

  gsap.fromTo(
    ".nav-left",
    { opacity: 0 },
    { opacity: 1, ease: "power1.in", duration: 0.6, delay: 2.0 }
  );
  gsap.fromTo(
    ".nav-right",
    { opacity: 0 },
    { opacity: 1, ease: "power1.in", duration: 0.6, delay: 2.0 }
  );
  gsap.fromTo(
    ".scrollPercentage-scroll",
    { opacity: 0 },
    { opacity: 1, ease: "power1.in", duration: 0.6, delay: 2.0 }
  );
  gsap.fromTo(
    ".scrollPercentage-scrollDown",
    { opacity: 0 },
    { opacity: 1, ease: "power1.in", duration: 0.6, delay: 2.0 }
  );
}

function destroyExperience() {
  if (!experienceInstance) return;
  experienceInstance.destroy();
  experienceInstance = null;
}


const handleBreakpoint = (isPhone) => {
  if (isPhone) {
    destroyExperience();
    renderPhoneProjects(data);
  } else {
    destroyPhoneProjects();
    startExperience();
  }
};

mq.addEventListener("change", (e) => handleBreakpoint(e.matches));
handleBreakpoint(mq.matches); 


window.addEventListener(
  "resize",
  debounce(() => {
    if (experienceInstance?.sizes) {
      experienceInstance.sizes.trigger("resize");
    }
  }, 150)
);
